<template>
    <div>
        <a-drawer
                :title="title"
                :width="720"
                :visible="visible"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <!--             <a-spin :spinning="spinning">-->
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
            >
                <a-form-model-item
                        ref="parent_id"
                        label="上级"
                        prop="parent_id"
                        :extra="formErr.parent_id"
                        :validateStatus='!formErr.parent_id||formErr.parent_id==[]?"":"error"'
                >
                    <a-cascader :options="formList.menuList" :fieldNames="fieldNames " placeholder="" change-on-select
                                v-model="form.parent_id" :allowClear="false"/>

                </a-form-model-item>
                <a-form-model-item
                        ref="title"
                        label="名称"
                        prop="title"
                        :extra="formErr.title"
                        :validateStatus='!formErr.title||formErr.title==""?"":"error"'
                >
                    <a-input
                            v-model="form.title"
                            @change="(e) => { formErr.title=''}"
                            @blur="(e) => {  form.title = e.target.value.trim() }"
                    />
                </a-form-model-item>

                <a-form-model-item
                        ref="name"
                        label="路由名称"
                        prop="name"
                        :extra="formErr.name"
                        :validateStatus='!formErr.name||formErr.name==""?"":"error"'
                >
                    <a-input
                            v-model="form.name"
                            @change="(e) => { formErr.name=''}"
                            @blur="(e) => {  form.name = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="component"
                        label="路由"
                        prop="component"
                        :extra="formErr.component"
                        :validateStatus='!formErr.component||formErr.component==""?"":"error"'
                >
                    <a-input
                            v-model="form.component"
                            @change="(e) => { formErr.component=''}"
                            @blur="(e) => {  form.component = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="path"
                        label="路径"
                        prop="path"
                        :extra="formErr.path"
                        :validateStatus='!formErr.path||formErr.path==""?"":"error"'
                >
                    <a-input
                            v-model="form.path"
                            @change="(e) => { formErr.path=''}"
                            @blur="(e) => {  form.path = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="param"
                        label="参数"
                        prop="param"
                        :extra="formErr.param"
                        :validateStatus='!formErr.param||formErr.param==""?"":"error"'
                >
                    <a-input
                            v-model="form.param"
                            @change="(e) => { formErr.param=''}"
                            @blur="(e) => {  form.param = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="icon"
                        label="图标"
                        prop="icon"
                        :extra="formErr.icon"
                        :validateStatus='!formErr.icon||formErr.icon==""?"":"error"'
                >
                    <a-input
                            v-model="form.icon"
                            @change="(e) => { formErr.icon=''}"
                            @blur="(e) => {  form.icon = e.target.value.trim() }"
                    />
                    <a class="hrefa" href="https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=9402"  target="_blank">选择图片</a><span>加前缀el-icon-b2c </span>

                </a-form-model-item>
                <a-form-model-item
                        ref="remark"
                        label="备注"
                        prop="remark"
                        :extra="formErr.remark"
                        :validateStatus='!formErr.remark||formErr.remark==""?"":"error"'
                >
                    <a-textarea   :rows="4" v-model="form.remark"
                                  @change="(e) => { formErr.remark=''}"
                                  @blur="(e) => {  form.remark = e.target.value.trim() }"/>
                    <!-- <a-button style="margin-left: 10px;" @click="resetForm">Reset</a-button> -->
                </a-form-model-item>
                <a-form-model-item
                        ref="status"
                        label="状态"
                        prop="status"
                        :extra="formErr.status"
                        :validateStatus='!formErr.status||formErr.status==""?"":"error"'
                >
                    <a-select v-model="form.status">
                        <a-select-option :value="item.value" v-for="(item, idx) in formList.status" :key="idx">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item
                        ref="type"
                        label="类型"
                        prop="type"
                        :extra="formErr.type"
                        :validateStatus='!formErr.type||formErr.type==[]?"":"error"'
                >
                    <a-select v-model="form.type">
                        <a-select-option :value="item.value" v-for="(item, index) in formList.menuType" :key="index">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
<!--                v-if="form.type==2"-->
                <a-form-model-item
                        ref="a_admin_menu_btn_id"
                        label="页面权限"
                        prop="a_admin_menu_btn_id"
                        :extra="formErr.a_admin_menu_btn_id"
                        :validateStatus='!formErr.a_admin_menu_btn_id||formErr.a_admin_menu_btn_id==[]?"":"error"'
                >
                    <a-select
                            v-model="form.a_admin_menu_btn_id"
                            mode="multiple"
                            style="width: 100%"
                    >
                        <a-select-option v-for="(item,index) in formList.menuBtn" :key="index"  :value="item.id" >
                            {{item.title}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
            <!--             </a-spin>-->

            <div class="drawer-btn"  >

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">确定</a-button>
                <a-button @click="onClose">取消</a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig} from "../../../utils/utils"
    import API from "../api";
    export default {
        name: "createForm",
        props: ["visible", "formEdit", "title", "ids", "editId" ],
        // props: {
        //     spinning: {
        //         type: Boolean,
        //         default: false
        //     },
        //     formEdit: {},
        //     title:{},
        //     ids:{},
        //     editId:{},
        //
        // },
        data() {
            return {
                drawerConfig ,
                fieldNames: {label: 'title', value: 'id', children: 'children'},
                fieldNames2: {label: 'name', value: 'id', children: 'children'},
                formList: [],
                formErr: {
                    parent_id: "",//父级id 0位一级分类
                    title: "",//菜单名称
                    name: "",//路由名称
                    component: "",//路由
                    path: "",//路径
                    a_admin_menu_btn_id: "",//菜单类型
                    status: "",//菜单状态
                    icon: "",//图标
                    param: "",//参数
                    remark: ""//备注
                },
                labelCol: {span: 4}, wrapperCol: {span: 14},
                form: {
                    parent_id: [],//父级id 0位一级分类
                    title: "",//菜单名称
                    name: "",//路由名称
                    component: "",//路由
                    path: "",//路径
                    a_admin_menu_btn_id: [],//菜单类型
                    status: "",//菜单状态
                    icon: "",//图标
                    param: "",//参数
                    remark: ""//备注
                },
                rules: {
                    parent_id: [{required: true, message: "请输入上级 ", trigger: "blur"}],
                    title: [{required: true, message: "请输入名称 ", trigger: "blur"}, {
                        whitespace: true,
                        message: "请输入名称 "
                    }],
                    name: [{required: true, message: "请输入路由名称 ", trigger: "blur"}, {
                        whitespace: true,
                        message: "请输入路由名称 ",
                    }],
                    component: [{required: true, message: "请输入路由 ", trigger: "blur"}, {
                        whitespace: true,
                        message: "请输入路由 "
                    }],
                    path: [{required: true, message: "请输入路径 ", trigger: "blur"}, {whitespace: true, message: "请输入路径 "}],
                    status: [{required: true, message: "请输入菜单状态 ", trigger: "blur"}],
                    type: [{required: true, message: "请输入按钮类型 ", trigger: "blur"}],
                    // a_admin_menu_btn_id: [{required: true, message: "页面权限不能为空", trigger: "blur"}],
                },
                visibles: false
            };
        },
        watch: {
            ids: function (a, b) {
                let parent_id=0
                this.formList.menuList.map((item,index)=>{
                    if(item.children){
                        item.children.map((items,indexs)=>{
                            if(items.id==a) {
                                parent_id=item.id
                            }
                        })
                    }
                })
                parent_id==0?this.form.parent_id = [a]:this.form.parent_id = [parent_id,a]

            },
            editId: function (a, b) {
                if (a != "") {
                    API.menu.EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        let parentId=val.arrparentid.split(",")
                        if(parentId.length>1) {
                            parentId.pop()
                        }else{
                            parentId=[val.parent_id]
                        }
                if(val.a_admin_menu_btn_id&&val.a_admin_menu_btn_id.length>0){
                    let a_admin_menu_btn_idArr=[]
                    val.a_admin_menu_btn_id.map((item,index)=>{
                        a_admin_menu_btn_idArr.push(item.id)
                    })
                    val.a_admin_menu_btn_id =a_admin_menu_btn_idArr
                }

                        val.parent_id =parentId.map(Number)
                        // val.type = [val.type, val.a_admin_menu_btn_id]
                        this.form = val

                    })
                } else {
                    this.form.id = ''
                }
            }

        },
        mounted() {
            this.getForm()
        },
        methods: {
            getForm(){
                API.menu.ADD_DATA().then(res => {
                    this.formList = res.data.data
                    let menuTypeArr = []
                    // this.formList.menuType.map((item, index) => {
                    //     let json = {}
                    //     json.title = item.name
                    //     json.id = item.value
                    //     menuTypeArr.push(json)
                    // })
                    // this.formList.menuType = menuTypeArr
                    // this.formList.menuBtn = res.data.data.menuBtn
                })
            },
            onClose() {
                this.$emit("changVisible", false);
                this.$refs.ruleForm.resetFields();
                this.form={
                    parent_id: [],//父级id 0位一级分类
                        title: "",//菜单名称
                        name: "",//路由名称
                        component: "",//路由
                        path: "",//路径
                        a_admin_menu_btn_id: [],//菜单类型
                        status: "",//菜单状态
                        icon: "",//图标
                        param: "",//参数
                        remark: ""//备注
                },
                this.formErr={parent_id: "", title: "", name: "", component: "",  path: "", a_admin_menu_btn_id: "", status: "",  icon: "", param: "", remark: "" }
                this.getForm()
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let formVal = JSON.parse(JSON.stringify(this.form))
                        // if (this.form.type.length > 1) {
                        //     formVal.a_admin_menu_btn_id = formVal.type[1]
                        //     formVal.type = formVal.type[0]
                        // } else {
                        //     formVal.a_admin_menu_btn_id = "", formVal.type = formVal.type[0]
                        // }
                        formVal.parent_id = formVal.parent_id[formVal.parent_id.length - 1]

                        if(!formVal.a_admin_menu_btn_id||formVal.a_admin_menu_btn_id.length<1){
                            formVal.a_admin_menu_btn_id=[""]
                        }

                        delete formVal["brnpermissions"];
                        let url = ""
                        this.form.id == '' || this.form.id == undefined ? url = API.menu.SUBMIT_ADD : url = API.menu.SUBMIT_EDIT
                        submitForm(url, formVal).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    };
</script>

<style scoped>
    .hrefa{color: #1890ff;display: inline-block;margin-right: 5px}
</style>
